/* Preview-only flash sale. Never creates or submits a checkout discount. */
(function (root) {
  'use strict';
  const eligibleIds = ['15866559856965', '15884235800901', '16003621159237', '16125747003717', '16114469994821'];
  function getState(now, startsAt, endsAt) {
    if (![now, startsAt, endsAt].every(Number.isFinite) || endsAt <= startsAt) return 'disabled';
    if (now < startsAt) return 'scheduled';
    return now >= endsAt ? 'ended' : 'active';
  }
  function parseTimestamp(value) {
    if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/.test(value.trim())) return NaN;
    return Date.parse(value.trim());
  }
  function resolveSchedule(startsAt, endsAt) {
    const start = parseTimestamp(startsAt);
    const end = typeof endsAt === 'string' && endsAt.trim() ? parseTimestamp(endsAt) : start + 72 * 3600000;
    return { start, end };
  }
  function discountedCents(cents) {
    if (!Number.isInteger(cents) || cents < 0) return null;
    return Math.round(cents * 70 / 100);
  }
  function remaining(now, end) {
    const total = Math.max(0, Math.ceil((end - now) / 1000));
    return [Math.floor(total / 86400), Math.floor(total / 3600) % 24, Math.floor(total / 60) % 60, total % 60];
  }
  function eligible(id) { return eligibleIds.includes(String(id)); }
  if (typeof module !== 'undefined' && module.exports) module.exports = { getState, discountedCents, remaining, eligible, resolveSchedule };
  if (!root.document) return;
  const configEl = document.getElementById('YeeseFlashConfig');
  if (!configEl) return;
  const config = JSON.parse(configEl.textContent);
  if (!config.live && (!config.preview || config.role !== 'unpublished')) return;
  const { start, end } = resolveSchedule(config.startsAt, config.endsAt);
  const serverNow = Date.parse(config.serverNow);
  const elapsedAtLoad = performance.now();
  const now = () => Number.isFinite(serverNow) ? serverNow + performance.now() - elapsedAtLoad : Date.now();
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', {
    style: 'currency', currency: config.currency || 'EUR'
  }).format(cents / 100);
  const currentState = () => {
    if (!config.timerEnabled || getState(now(), start, end) === 'disabled') return 'disabled';
    if (!config.live && (config.demoState === 'scheduled' || config.demoState === 'ended')) return config.demoState;
    return getState(now(), start, end);
  };
  function tick() {
    const state = currentState();
    document.documentElement.dataset.yeeseFlashState = state;
    document.querySelectorAll('[data-flash-time-error]').forEach(node => { node.hidden = state !== 'disabled'; });
    document.querySelectorAll('[data-yeese-flash-countdown]').forEach((clock) => {
      const parts = state === 'disabled' ? [0, 0, 0, 0] : remaining(now(), end);
      clock.querySelectorAll('[data-flash-unit]').forEach((node, i) => { node.textContent = String(parts[i]).padStart(2, '0'); });
    });
  }
  class FlashOffer extends HTMLElement {
    connectedCallback() {
      if (this.dataset.collectionEligible !== 'true') { this.hidden = true; return; }
      this.form = this.closest('product-form');
      this.onVariant = (event) => {
        const variant = event.detail && event.detail.variant;
        this.updatePrice(variant ? variant.price : null, Boolean(variant && variant.available));
      };
      if (this.form) this.form.addEventListener('on:variant:change', this.onVariant);
      this.updatePrice(this.dataset.price === '' ? null : Number(this.dataset.price), this.dataset.available === 'true');
    }
    disconnectedCallback() {
      if (this.form) this.form.removeEventListener('on:variant:change', this.onVariant);
    }
    updatePrice(cents, available) {
      const discounted = discountedCents(cents);
      const price = this.querySelector('[data-yeese-event-price]');
      const select = this.querySelector('[data-yeese-select-size]');
      const row = this.querySelector('[data-yeese-event-row]');
      if (price) price.textContent = discounted === null ? '' : money(discounted);
      if (row) row.hidden = !available || discounted === null;
      if (select) select.hidden = available && discounted !== null;
    }
  }
  if (!customElements.get('yeese-flash-offer')) customElements.define('yeese-flash-offer', FlashOffer);
  document.querySelectorAll('[data-flash-demo-control]').forEach((control) => {
    control.value = config.demoState;
    control.addEventListener('change', () => { config.demoState = control.value; tick(); });
  });
  async function loadAllProducts(grid) {
    let next = grid.dataset.nextUrl;
    const visited = new Set();
    try {
      while (next) {
        const url = new URL(next, location.href);
        if (url.origin !== location.origin || visited.has(url.href)) throw new Error('Invalid collection continuation');
        visited.add(url.href);
        url.searchParams.set('section_id', grid.dataset.sectionId);
        url.searchParams.set('view', 'yeese-flash-sale');
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Collection load failed');
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        const batch = page.querySelector('[data-flash-grid]');
        if (!batch) throw new Error('Collection grid missing');
        const existing = new Set(Array.from(grid.children, card => card.dataset.flashProduct));
        for (const card of Array.from(batch.children)) {
          if (!existing.has(card.dataset.flashProduct)) grid.append(card);
        }
        next = batch.dataset.nextUrl;
      }
    } catch (error) {
      const message = grid.closest('.yeese-flash-selection').querySelector('[data-flash-load-error]');
      if (message) message.hidden = false;
    }
  }
  document.querySelectorAll('[data-flash-grid][data-next-url]').forEach(loadAllProducts);
  tick();
  setInterval(tick, 1000);
  document.addEventListener('visibilitychange', tick);
})(typeof window === 'undefined' ? globalThis : window);
